// extracted by mini-css-extract-plugin
export var columnList = "_hb-0";